<template>
  <header class="app-header" :class="{ 'is-scrolled': isScrolled }">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <!-- Logo Image -->
          <img src="@/assets/logo.png" alt="星矩链动" class="logo-img">
          <span class="logo-text">星矩链动</span>
        </router-link>
      </div>
      <nav class="main-nav">
        <router-link to="/">首页</router-link>
        <router-link to="/solutions">解决方案</router-link>
        <router-link to="/about">关于我们</router-link>
        <router-link to="/contact" class="nav-btn">联系我们</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data () {
    return {
      isScrolled: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.isScrolled = window.scrollY > 50
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeInRight {
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes gradientFlow {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.app-header {
  background-color: rgba(16, 20, 26, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.35);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  height: 80px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'PingFang SC', sans-serif;
  animation: slideDown 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);

  &.is-scrolled {
    height: 64px;
    background-color: rgba(16, 20, 26, 0.9);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  }

  .container {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 30px;
  }

  .logo {
    animation: fadeInRight 0.8s ease-out 0.2s backwards;

    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      gap: 12px;
    }

    .logo-img {
      height: 40px;
      width: auto;
      object-fit: contain;
      transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
    }

    .logo-text {
      font-size: 24px;
      font-weight: 800;
      color: var(--text);
      letter-spacing: 1px;
      background: linear-gradient(90deg, var(--accent), #17c777, var(--accent-2));
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      transition: all 0.3s;
    }

    &:hover {
      .logo-img {
        transform: rotate(10deg) scale(1.1);
        filter: drop-shadow(0 5px 15px rgba(0, 97, 255, 0.3));
      }

      .logo-text {
        animation: gradientFlow 3s linear infinite;
      }
    }
  }

  .main-nav {
    display: flex;
    align-items: center;
    gap: 40px;
    animation: fadeInRight 0.8s ease-out 0.4s backwards;

    a {
      text-decoration: none;
      color: var(--muted);
      font-size: 16px;
      font-weight: 500;
      transition: all 0.3s;
      position: relative;
      padding: 5px 0;

      &:not(.nav-btn) {
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border-radius: 2px;
          transform: translateX(-50%);
          opacity: 0;
        }

        &:hover, &.router-link-active {
          color: var(--text);
          text-shadow: 0 0 2px rgba(34, 229, 143, 0.3);

          &::after {
            width: 100%;
            opacity: 1;
            bottom: 0;
          }
        }

        &.router-link-active {
          font-weight: 600;
        }
      }

      &.nav-btn {
        padding: 10px 28px;
        background: linear-gradient(135deg, var(--accent) 0%, var(--accent-2) 50%, var(--accent) 100%);
        background-size: 200% 100%;
        color: #fff;
        border-radius: 50px;
        font-weight: 600;
        box-shadow: 0 4px 15px rgba(34, 229, 143, 0.35);
        transition: all 0.4s ease;
        position: relative;
        overflow: hidden;

        &:hover {
          transform: translateY(-2px) scale(1.02);
          box-shadow: 0 8px 25px rgba(34, 229, 143, 0.5);
          background-position: 100% 0;
        }

        &:active {
          transform: translateY(0) scale(0.98);
        }
      }
    }
  }
}
</style>
